<template>
  <div class="form-text">
    <input type="text" v-model="model" />
  </div>
</template>

<script>
export default {
  name: 'ElementFormText',
  props: {

  },
  data () {
    return {
      model: ''
    }
  },
  watch: {
    model: {
      deep: true,
      handler () {
        this.$emit('change', this.model)
      }
    }
  }
}

</script>

<style lang="scss">
  .form-text{}
</style>
